export const QUANTIDADES_PRESET_COMPRA_RAPIDA = [3, 5, 8, 10, 15, 20] as const;
